import React from "react";
import { getEstadoInteresBadgeClass, getEstadoInteresLabel } from "../../../../utils/estadoInteres";

export default function BitacoraTable({
  filas,
  interesados,
  getBadgeClass,
  onEdit,
  onSalida,
  canEdit,
  canClose,
  recargarDatos,
  recargando,
}) {
  const registrosTotales = filas.length;

  return (
    <div className="management-card">
      <div className="d-flex flex-wrap gap-3 justify-content-between align-items-center mb-3">
        <div>
          <p className="management-label mb-1">Registro de entradas y salidas</p>
          <h5 className="mb-0">Actualizado en tiempo real</h5>
        </div>
        <div className="d-flex align-items-center gap-2">
          <span className="management-pill">
            <i className="bi bi-people" />
            {registrosTotales} registros
          </span>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-2"
            onClick={recargarDatos}
            disabled={recargando}
          >
            {recargando ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                <span>Actualizando</span>
              </>
            ) : (
              <>
                <i className="bi bi-arrow-clockwise" aria-hidden="true" />
                <span>Actualizar</span>
              </>
            )}
          </button>
        </div>
      </div>
      <div className="management-table-wrapper table-responsive">
        <table className="table align-middle management-table">
          <thead>
            <tr>
              <th className="text-center">#</th>
              <th>Nombre</th>
              <th>Cedula</th>
              <th>Telefono</th>
              <th>Entrada</th>
              <th>Salida</th>
              <th>Observacion</th>
              <th>Novedad</th>
              <th>Estado interesado</th>
              <th className="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {recargando && filas.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center py-5">
                  <div className="d-flex justify-content-center align-items-center gap-2 text-muted">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    <span>Cargando registros...</span>
                  </div>
                </td>
              </tr>
            ) : filas.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center py-5">
                  <div className="dashboard-empty">
                    <i className="bi bi-inboxes dashboard-empty-icon mb-2" />
                    <p className="mb-0">No hay registros para la fecha seleccionada</p>
                    <small className="text-muted">Crea un nuevo registro o ajusta el filtro</small>
                  </div>
                </td>
              </tr>
            ) : (
              filas.map((row, index) => {
                const interesado = interesados.find((i) => i.id === row.interesado_id);
                return (
                  <tr key={row.id}>
                    <td className="fw-semibold text-muted text-center">{registrosTotales - index}</td>
                    <td>
                      <div className="fw-semibold">{interesado?.nombre || "Sin nombre"}</div>
                      <small className="text-muted">{interesado?.email || "-"}</small>
                    </td>
                    <td>{interesado?.documento || "-"}</td>
                    <td>{interesado?.telefono || "-"}</td>
                    <td>{row.entrada || "-"}</td>
                    <td>{row.salida || "-"}</td>
                    <td className="text-start">{row.observacion || "-"}</td>
                    <td>
                      <span className={`badge rounded-pill dashboard-status ${getBadgeClass(row.novedad)}`}>
                        {row.novedad || "N/A"}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`badge rounded-pill px-3 py-2 ${getEstadoInteresBadgeClass(row.estado_interes)}`}
                      >
                        {getEstadoInteresLabel(row.estado_interes)}
                      </span>
                    </td>
                    <td className="text-center">
                      {canEdit && (
                        <button
                          type="button"
                          className="btn btn-icon dashboard-icon-button management-action-btn me-2"
                          aria-label="Editar registro"
                          onClick={() => onEdit?.(row)}
                        >
                          <i className="bi bi-pen" />
                        </button>
                      )}
                      {!row.salida && canClose && (
                        <button
                          type="button"
                          className="btn btn-icon dashboard-icon-button warning management-action-btn"
                          aria-label="Registrar salida"
                          onClick={() => onSalida?.(row.id)}
                        >
                          <i className="bi bi-box-arrow-right" />
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
